import { onBeforeUnmount, onMounted, ref } from 'vue'

const val = ref<number>(0)
let observed = false

let observer: ResizeObserver | null = null

if (!import.meta.env.SSR) {
  observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
    for (const entry of entries) {
      const borderBoxSize = entry.borderBoxSize

      if (borderBoxSize && borderBoxSize.length) {
        const width = borderBoxSize[0].inlineSize

        if (width !== val.value) {
          val.value = width
        }
      }
    }
  })
}

export function useResizeObserver() {
  onMounted(() => {
    if (!observed && observer !== null) {
      observer.observe(document.body)

      observed = true
    }
  })

  onBeforeUnmount(() => {
    if (!observer) {
      return
    }

    observer.unobserve(document.body)
    observer.disconnect()
  })

  return {
    val,
  }
}
